import { $insertNodeToNearestRoot } from '@lexical/utils'
import { $createParagraphNode, $isParagraphNode, LexicalNode } from 'lexical'

export const $focusNode = (node: LexicalNode) => {
  node.selectStart()
}

export const $wrapIsolatedNode = (node: LexicalNode) => {
  const parent = $createParagraphNode()
  // const startFiller = $createFillerNode()
  // const endFiller = $createFillerNode()
  // parent.append(startFiller)
  parent.append(node)
  // parent.append(endFiller)
  return parent
}

export const $insertIsolatedNodeToNearestRoot = (node: LexicalNode) => {
  const wrapNode = $wrapIsolatedNode(node)
  $insertNodeToNearestRoot(wrapNode)
  const prevSibling = wrapNode.getPreviousSibling()
  if ($isParagraphNode(prevSibling) && prevSibling.isEmpty()) {
    prevSibling.remove()
  }
}

/**
 * 获取 node 指定类型的父节点
 */
export const $findParentNode = <T extends LexicalNode>(
  node: LexicalNode | null,
  $predicate: (node: LexicalNode) => node is T
) => {
  let currentNode = node

  while (currentNode) {
    if ($predicate(currentNode)) {
      return currentNode
    }
    currentNode = currentNode.getParent()
  }

  return undefined
}

/**
 * 获取 node 指定类型的父节点，找不到则抛出异常
 */
export const $findParentNodeOrThrow = <T extends LexicalNode>(
  node: LexicalNode | null,
  $predicate: (node: LexicalNode) => node is T
) => {
  const parentNode = $findParentNode(node, $predicate)
  if (!parentNode) {
    throw new Error('Parent node not found')
  }
  return parentNode
}
